import { FC } from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import styled from 'styled-components';
import { Spacing } from '../../../assets/GlobalStyle/Variables';

export const FieldSkeleton: FC = () => {
  return (
    <FieldWrapper>
      <Skeleton width={200} height={16} style={{ marginBottom: '8px' }} />
      <Skeleton height={42} />
    </FieldWrapper>
  );
};

export const SelectSkeleton: FC = () => {
  return (
    <SelectWrapper>
      <Skeleton width={200} height={16} style={{ marginBottom: '8px' }} />
      <Skeleton height={42} />
    </SelectWrapper>
  );
};

export const TextareaSkeleton: FC<{ rows?: number }> = ({ rows = 3 }) => {
  return (
    <TextareaWrapper>
      <Skeleton width={200} height={16} style={{ marginBottom: '8px' }} />
      <Skeleton height={rows * 20 + 22} />
    </TextareaWrapper>
  );
};

export const CheckboxSkeleton: FC = () => {
  return (
    <CheckboxWrapper>
      <Skeleton width={20} height={20} style={{ marginRight: '8px' }} />
      <Skeleton width={100} height={16} />
    </CheckboxWrapper>
  );
};

export const ButtonSkeleton: FC<{ width?: number }> = ({ width = 120 }) => {
  return <Skeleton width={width} height={40} />;
};

export const TableSkeleton: FC = () => {
  return (
    <TableWrapper>
      <Skeleton height={50} style={{ marginBottom: '1px' }} />
      <Skeleton height={40} style={{ marginBottom: '1px' }} />
      <Skeleton height={40} />
    </TableWrapper>
  );
};

const FieldWrapper = styled.div`
  margin-bottom: ${Spacing(8)};
`;

const SelectWrapper = styled.div`
  margin-bottom: ${Spacing(8)};
`;

const TextareaWrapper = styled.div`
  margin-bottom: ${Spacing(8)};
`;

const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: ${Spacing(8)};
`;

const TableWrapper = styled.div`
  margin-top: ${Spacing(4)};
`;
